import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const BrandCarousel = () => {
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3002';
    
    fetch(`${API_URL}/api/products/brands`)
      .then(res => res.json())
      .then(data => {
        const filtered = Array.isArray(data) 
          ? data.filter(b => b.name && b.name.toLowerCase() !== 'uncategorized')
          : [];
        setBrands(filtered);
      })
      .catch(err => {
        console.error('[BrandCarousel] Fetch error:', err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div className="py-12 px-4">
        <div className="flex gap-8 justify-center overflow-hidden">
          {[...Array(6)].map((_, i) => (
            <div key={i} className="w-24 h-12 bg-gray-200 animate-pulse rounded flex-shrink-0">
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (brands.length === 0) {
    return null;
  }

  return (
    <section className="py-12 border-t">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-xl font-bold mb-8 text-center">Featured Brands</h2>
        <div className="flex items-center justify-center gap-8 flex-wrap">
          {brands.map((brand) => (
            <Link 
              key={brand.id} 
              to={`/brands?brand=${encodeURIComponent(brand.name)}`} 
              className="flex-shrink-0 flex items-center justify-center h-16 px-6 bg-white rounded-lg shadow-sm border border-gray-100 hover:shadow-md transition-shadow"
            >
              {brand.logo ? (
                <img 
                  src={brand.logo} 
                  alt={brand.name}
                  className="h-10 w-auto object-contain grayscale hover:grayscale-0 transition-all"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />
              ) : null}
              <span 
                className="text-sm font-semibold text-gray-700"
                style={brand.logo ? { display: 'none' } : {}}
              >
                {brand.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BrandCarousel;